<app-ai-summary-source-bar
	*ngIf="channelItems.length"
	title="Mentions by channel"
	[items]="channelItems"
></app-ai-summary-source-bar>

<app-ai-summary-source-bar
	*ngIf="reviewItems.length"
	title="Reviews by source"
	[items]="reviewItems"
></app-ai-summary-source-bar>
